import styled from "styled-components";

import { ContainerComponent } from "../../ui";

export const Wrapper = styled("section")(({ theme, variant }) => ({
  height: variant === "full" ? 700 : "auto",
  background:
    variant === "full"
      ? `linear-gradient(180deg, rgba(15, 42, 71, 0.7) 0%, rgba(26, 58, 95, 0.6) 40%, rgba(45, 74, 111, 0.7) 100%),
       url(/images/background-3.jpg)`
      : "linear-gradient(180deg, #0f2a47 0%, #1a3a5f 40%, #2d4a6f 100%)",
  backgroundColor: variant === "full" ? "" : "#1a3a5f",
  backgroundSize: "cover",
  backgroundPosition: "center center",
  backgroundRepeat: "no-repeat",
  marginBottom: 0,

  [theme.down("xl")]: {
    height: variant === "full" ? 500 : "auto",
  },

  [theme.down("sm")]: {
    height: "auto",
  },
}));

export const WrapperContainer = styled(ContainerComponent)(({ theme }) => ({
  height: "100%",
  position: "relative",

  [theme.down("sm")]: {
    ...theme.paddings(20, 0),
  },
}));
